import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {
  cancelConfiguration, setActiveStep, preSaveConfiguration, setServicePlanActivation, shareConfiguration, renameConfiguration,
  updateMsxSoftwareLicenseReferences,
} from '../../configuration-management/ducks';
import { openModal, closeModal } from '../../modals/ducks';
import { stepsConfig, configurationStatuses, surveyTypes, surveyEventTypes, eventForceShowingSurvey, softwareStepsConfig, LICENSE_MODELS, BUY_AUTOMATION_URLS, SUBSTITUTION_TYPE_REPLACE, licenseDocumentationKeys, IAC_SEND_MAIL_EVENT_NAMES } from '../../../constants';
import { getSoftwareStepperLabels } from '../../../utils/linear-stepper';
import I10n from '../../i10n';
import Configuration from '../../../models/Configuration';
import { setApplicationParameters } from '../../../utils/application-parameters/ducks';
import { appConfiguration } from '../../../utils/app-starter';
import ApplicationFullHeader from '../../../components/application_full_header';
import Scrollbars from 'react-custom-scrollbars';
import { getSurvey } from '../../survey-management/ducks';
import Survey from '../../../components/survey';
import { logDocumentationExportEvent, logSurveyOpenEvent, logSurveySubmitEvent, raiseIACAnalyticsEvent } from '../../../utils/analytics-logger';
import { updateShowButtonAnimations } from '../start_configuration_screen/ducks';
import { buildMySchneiderUrl } from '../../../utils/url-builder';
import Button from '../../../atoms/button';
import { getDocumentation, getDatasheet, downloadDocuments } from '../../documentation-management/ducks';
import BillOfMaterialsLicence from '../../../components/software_licence/bill_of_materials_licence';
import { getUserInformation, setUserInformation } from '../../user-information/ducks';
import LicenceSavedConfigurationSection from '../../../components/software_licence/licence_saved_configuration_section';
import EmailFormModal from '../../../components/email_form_modal';
import { exportToBuyAutomation, exportToMyList, exportToMyProduct, exportToMyProject, exportToXLS } from '../../export/ducks';
import { showNotificationWithButton } from '../../notification/ducks';
import DocumentationSection from '../../../components/documentation_section';
import { resetCBRSelectedItems } from '../../call-by-range/ducks';
import Notification from '../../notification';
import { checkBuyAutomationAccountExists } from './ducks';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden;
  background-color: #F4F4F4;

  @media (max-width: 800px) {
    position: fixed;
    z-index: 300;
    top: 0px;left: 0px;right:0px;bottom: 0px;
    overflow: auto;
    padding: 0px;
  }
  ${props => props.fullScreenEnabled && `
    position: fixed;
    z-index: 300;
    top: 0px;left: 0px;right:0px;bottom: 0px;
    overflow: auto;
    padding: 0px;
  `}
`;

const FullScreenScrollbarWrapper = styled.div`
  height: 100%;
`;

const ScreenContent = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0px 24px 0px 16px;
  flex: 1 1 0px;
  ${props => props.fullScreenEnabled && `
    height: 100%;
  `}
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
`;

const Content = styled.div`
  flex: 1 1 100%;
  display: flex;
  flex-direction: row;
  @media(max-width: 800px) {
    display: block;
  }
`;

const BOMContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 3 1 0px;
  @media (max-width: 800px) {
    display: none;
  }
`;

const BomWrapper = styled.div`
  padding-top: 10px;
  padding-right: 16px;
  @media (max-width: 800px) {
    padding-top: 0px;
    padding-right: 0px;
  }
`;

const MobileSection = styled.div`
  display: none;
  flex-direction: column;
  @media (max-width: 800px) {
    display: flex;
    margin-top: 5px;
  }
`;

const SaveWrapper = styled.div`
  border: 1px solid #e7e6e6;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 12px;
  margin: 15px 16px 15px 0px;
  padding: 24px;
  background-color: white;
  display: flex;
  flex-direction: column;
  flex: 2 1 0px;
  @media (max-width: 800px) {
    padding: 16px;
  }
`;

const DocumentationWrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  margin-top: 5px;
`;

const FullScreenNavigationButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
  position: fixed;
  bottom: 0; left: 0; right: 0;
  transform: translate3d(0,0,0);
  z-index: 30;
  background-color: white;
  border-top: 2px solid #EDEDED;
`;

const HiddenNavigationButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
  background-color: white;
  border-top: 2px solid #EDEDED;
  visibility: hidden;
`;

const MigrationWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const MigrationButtonWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
  justify-content: flex-end;
`;

const MigrationLabel = styled.span`
  margin-right: 5px;
`;

const OutdatedLicenseModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const OutdatedLicenseModalLabel = styled.span`
  margin-bottom: 10px;
`;

const OutdatedLicenseModalRowLabel = styled.span`
  margin-bottom: 5px;
`;

const CancelWrapper = styled.div`
  margin-right: 10px;
`;

class LicenceSelectorSaveScreen extends React.Component {

  shouldShowDisclaimer = () => {
    let disclaimerExpired = true;

    try {
      const lastDisclaimerConfirmed = localStorage.getItem('plc_licence_customer_service_disclaimer_days');

      if (lastDisclaimerConfirmed) {

        const date = new Date();
        date.setDate(date.getDate() - 30);

        if (date.getTime() < Number(lastDisclaimerConfirmed)) {
          disclaimerExpired = false;
        }
      }
    } catch(error) {}

    return disclaimerExpired;
  }

  constructor(props) {
    let showSurveyDisclaimer = false;
    try {
      if (props.configuration.showSurveyDisclaimer && appConfiguration.campaignId && localStorage.getItem(`iac-campaign-${appConfiguration.campaignId}`) == null) {
        showSurveyDisclaimer = true;
      }
    } catch(e) {}

    super(props);
    this.state = {
      emailForm: { isOpen: false, configuration: null },
      isDesktop: window.innerWidth > 800,
      workspaceOptionsOpened: false,
      buyAutomationAccountExists: false,
      buyAutomationAccountId: null,
      buyAutomationCheckingAccountLoading: false,
      buyAutomationAddToCartPerformed: false,
      showSurveyDisclaimer: showSurveyDisclaimer,
      showDisclaimer: this.shouldShowDisclaimer()
    };
    this._isMounted = false;
  }

  updateIsDesktop = () => {
    if (this.state.isDesktop && window.innerWidth <= 800) {
      this.setState({ isDesktop: false });
    } else if (!this.state.isDesktop && window.innerWidth > 800) {
      this.setState({ isDesktop: true });
    }
  }

  get _isWrapperMode() {
    return window.self !== window.top;
  }

  componentDidMount = () => {
    window.addEventListener("resize", this.updateIsDesktop);
    this.props.getSurvey().then(() => {
      if (this.props.showButtonAnimations?.survey) {
        window.dispatchEvent(new Event(eventForceShowingSurvey));
      }
    }).finally(() => {
      this.props.updateShowButtonAnimations();
    });
    this.props.getDatasheet(this.props.configuration);
    this.props.getDocumentation(this.props.configuration);

    if (this.shouldCallBuyAutomation()) {
      this.setState({buyAutomationCheckingAccountLoading: true});

      checkBuyAutomationAccountExists().then((result) => {
        this.setState({buyAutomationAccountExists: result?.exists, buyAutomationAccountId: result.accountId});
      })
      .catch(() => {
        this.setState({buyAutomationAccountExists: false});
      })
      .finally(() => {
        this.setState({buyAutomationCheckingAccountLoading: false});
      });
    }

    this._isMounted = true;
  }

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.updateIsDesktop);
    this._isMounted = false;
    this.props.closeModal();
  }

  updateStateIfMounted(state) {
    if (this._isMounted) {
      this.setState(state);
    }
  }

  shouldCallBuyAutomation = () => {
    let shouldCallBuyAutomation = false;

    if (appConfiguration.seamlessSession) {
      shouldCallBuyAutomation = !!(appConfiguration.seamlessSession?.isInternal && LICENSE_MODELS.SUBSCRIPTION === this.props.configuration.licenseModel);
    }
    return shouldCallBuyAutomation;
  }

  handleDownloadDocuments = (documents, documentName) => {
    return downloadDocuments(documents, this.props.configuration.name, documentName);
  }

  logDocumentationExport = (exportName, extension) => {
    logDocumentationExportEvent(this.props.configuration, exportName, extension);
  }

  showDuplicateConfirmationModal = (callback) => {
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    if (isSaved && !this.props.configuration.allowSavedModifications) {
      this.props.openModalFct({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => { this.props.closeModal(); },
          onSubmit: () => {
            this.props.closeModal();
            callback();
          },
          title: I10n.get('modal.change_saved_configuration.title'),
          text: I10n.get('modal.change_saved_configuration.body'),
          cancelText: I10n.get('app.action.cancel'),
          submitText: I10n.get('app.action.continue'),
        }
      });
    } else {
      callback();
    }
  }

  buildBuyAutomationCartURL = () => {
    const environment = process.env.REACT_APP_SEAMLESS_ENV || 'prod';
    const buyAutomationURL = BUY_AUTOMATION_URLS[environment]?.CART_LANDING_PAGE || BUY_AUTOMATION_URLS.prod.CART_LANDING_PAGE;

    return buyAutomationURL + this.state.buyAutomationAccountId;
  }

  addToBuyAutomation = (configuration) => {
    return this.props.exportToBuyAutomation(configuration).then(() => {
      this.setState({buyAutomationAddToCartPerformed: true});
      this.props.showNotification(
        I10n.get('add_to_buy_automation.notification'),
        'success',
        () => (
          <Button onClick={() => {
            window.open(this.buildBuyAutomationCartURL(), '_blank'); }}>
            {I10n.get('buy_automation.notification.button')}
          </Button>
        )
      );
    }).catch(() => {
      this.props.showNotification(
        I10n.get('add_to_buy_automation.notification.error'),
        'error',
        null
      );
    });
  }

  addToMyProduct = (configuration) => {
    if (appConfiguration.isWorkspaceAvailable || appConfiguration.unifiedCheckoutAvailable) {
      this.props.exportToMyProject(configuration);
    } else {
      const x = this.props.exportToMyProduct(configuration);
      x.then(() => {}).catch(() => {
        this.props.showNotification(
          I10n.get('add_to_my_product.notification.error'),
          'error',
          null
        );
      });
    }
  }

  addToMyList = (config) => {
    this.props.exportToMyList(config);
  }

  buildOutdatedLicensesModalContent = () => {
    return (<OutdatedLicenseModalContentWrapper>
      <OutdatedLicenseModalLabel>
        {I10n.get('screen.licence_selector.outdated_licences.modal.body')}
      </OutdatedLicenseModalLabel>
      {this.props.configuration.outdatedLicenses.map((outdatedItem, idx) => {
        if (outdatedItem.outdatedType === SUBSTITUTION_TYPE_REPLACE) {
          return <OutdatedLicenseModalRowLabel key={idx}>{I10n.getAndReplaceMultiple('screen.licence_selector.outdated_licences.modal.updated', [outdatedItem.oldLicense, outdatedItem.newLicense])}</OutdatedLicenseModalRowLabel>;
        }
        return <OutdatedLicenseModalRowLabel key={idx}>{I10n.getAndReplace('screen.licence_selector.outdated_licences.modal.removed', outdatedItem.oldLicense)}</OutdatedLicenseModalRowLabel>;
      })}
    </OutdatedLicenseModalContentWrapper>);
  }

  renderBOM = (config) => {
    return (
      <ContentWrapper fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
        {(this.props.configuration.outdatedLicenses || []).length > 0 && <MigrationWrapper>
          <MigrationLabel>{I10n.get('screen.licence_selector_save_screen.outdated_licences_detected')}</MigrationLabel>
          <MigrationButtonWrapper>
            <Button primary disabled={this.props.configurationSaver.isSaving} onClick={() => {
              this.props.openModalFct({
                modalType: 'confirmation',
                modalProps: {
                  onCancel: () => {
                    this.props.closeModal();
                  },
                  onSubmit: () => {
                    this.props.closeModal();
                    this.props.updateMsxSoftwareLicenseReferences(this.props.configuration);
                  },
                  title: I10n.get('screen.licence_selector.outdated_licences.modal.title'),
                  text: this.buildOutdatedLicensesModalContent(),
                  cancelText: I10n.get('app.action.no'),
                  submitText: I10n.get('app.action.yes')
                }
              });
            }}>{I10n.get('screen.licence_selector_save_screen.outdated_licences_detected.update')}</Button>
          </MigrationButtonWrapper>
        </MigrationWrapper>}
        <BillOfMaterialsLicence
          configuration={config}
          licenseGroups={config.getSoftwareLicences()}
          servicePlanItems={config.servicePlanItems}
          servicePlanActivated={config.servicePlanActivated}
          setServicePlanActivation={(newStatus) => { this.props.setServicePlanActivation(newStatus); }}
          isSaving={this.props.configurationSaver.isSaving}
          setConfigurationName={(name) => {
            this.props.renameConfiguration(config.id, name)
          }}
        />
      </ContentWrapper>
    );
  }

  confirmationBeforeCancel = (isSaved, cancelCallback) => {
    if (!isSaved) {
      this.props.openModalFct({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => {
            this.props.closeModal();
          },
          onSubmit: () => {
            cancelCallback();
            this.props.cancelConfiguration(this.props.configuration.id);
            this.props.closeModal();
          },
          title: I10n.get('screen.config_editor.modal_cancel.title'),
          text: I10n.get('screen.config_editor.modal_cancel.body'),
          cancelText: I10n.get('app.action.return'),
          submitText: I10n.get('app.action.confirm'),
        }
      });
    } else {
      cancelCallback();
    }
  }

  checkSoftwareLicenceAvailability = (callback) => {
    if (!appConfiguration.technologies.software_licence) {
      this.props.openModalFct({
        modalType: 'information',
        modalProps: {
          onButtonClick: () => { this.props.closeModal(); },
          text: I10n.get('modal.error.software_selector_not_available'),
          buttonText: I10n.get('app.action.close'),
        },
      });
    } else {
      callback();
    }
  };

  getStepperActions = (isSaved) => {
    return [
      { action: () => {
        this.checkSoftwareLicenceAvailability(() => {
          this.props.resetCallByRangeSelectedItems();
          this.props.setActiveStep(softwareStepsConfig.software_selection);
        });
      }, active: true, done: true },
      { action: () => {
        this.checkSoftwareLicenceAvailability(() => {
          this.props.resetCallByRangeSelectedItems();
          this.props.setActiveStep(softwareStepsConfig.licence_selector);
        });
      }, active: true, done: true },
      { action: () => {
        this.checkSoftwareLicenceAvailability(() => {
          this.props.resetCallByRangeSelectedItems();
          this.props.setActiveStep(softwareStepsConfig.service_plan);
        });
      }, active: true, done: true, hidden: this.props.configuration.servicePlanItems?.length === 0 },
      { action: () => {
      }, active: true, done: isSaved},
    ];
  }

  onSendMail = (configuration) => {
    const mailInformation = getUserInformation();
    this.props.openModalFct({
      modalType: 'send-email',
      modalProps: {
        senderName: mailInformation.senderName,
        senderEmail: mailInformation.senderEmail,
        onCancel: () => { this.props.closeModal(); },
        onSubmit: (formData) => {
          this.props.closeModal();
          const configurationId = configuration.id;
          const configurationName = configuration.name;
          setUserInformation(formData.senderEmail, formData.senderName);
          let sharePromise;
          if (formData.sendToMyself) {
            sharePromise = shareConfiguration(configurationId, formData.senderEmail, formData.senderName, null, null, null, formData.captchaResponse, true, I10n.get('save_configuration.email.subject'));
          } else {
            sharePromise = shareConfiguration(configurationId, formData.senderEmail, formData.senderName, formData.recipientEmail, formData.recipientName, formData.message, formData.captchaResponse, true, I10n.get('save_configuration.email.subject'));
          }
          sharePromise.then(() => {
            raiseIACAnalyticsEvent(IAC_SEND_MAIL_EVENT_NAMES.SEND_MAIL);
            this.props.showNotification(I10n.getAndReplace('save_configuration.email_sent.notification', configurationName), 'succes', () => null);
          })
            .catch((error) => {
              console.log(error);
            });

        },
      }
    });
  }

  processDocumentationKeys = (config) => {
    let result = [...licenseDocumentationKeys];
    if (config?.softwareInfo?.documentationDisplaySelector) {
      result = result.filter(key => config.softwareInfo.documentationDisplaySelector.shouldDisplayKey(key));
    }
    return result;
  }

  renderSavedSection = (config) => {
    return (<SaveWrapper>
      <LicenceSavedConfigurationSection
        configuration={config}
        addToMyProduct={this.addToMyProduct}
        addToMyList={this.addToMyList}
        addToMyProductLabel={appConfiguration.addToMyProductLabel}
        addToListLabel={appConfiguration.addToListLabel}
        addToBuyAutomation={this.addToBuyAutomation}
        exportToXls={this.props.exportToXls}
        export={this.props.export}
        showNotification={this.props.showNotification}
        handleEmailFormOpen={this.onSendMail}
        shouldCallBuyAutomation={this.shouldCallBuyAutomation()}
        buyAutomationAccountExists={this.state.buyAutomationAccountExists}
        buyAutomationCheckingAccountLoading={this.state.buyAutomationCheckingAccountLoading}
        buyAutomationCartURL={this.buildBuyAutomationCartURL()}
        buyAutomationAddToCartPerformed={this.state.buyAutomationAddToCartPerformed}
        openModal={this.props.openModalFct}
        closeModal={this.props.closeModal}
        isWrapperMode={this._isWrapperMode}
        allowSavedModifications={this.props.configuration.allowSavedModifications}
        workspaceOptionsOpened={this.state.workspaceOptionsOpened}
        toggleWorkspaceOptions={() => { this.setState({ workspaceOptionsOpened: !this.state.workspaceOptionsOpened }); }}
        seamlessSession={appConfiguration.seamlessSession}
        launchFromWorkspace={appConfiguration.launchFromWorkspace}
        isWorkspaceAvailable={appConfiguration.isWorkspaceAvailable}
        unifiedCheckoutAvailable={appConfiguration.unifiedCheckoutAvailable}
        showDisclaimer={this.state.showDisclaimer}
        onDisclaimerDismiss={() => { this.setState({showDisclaimer: false}); try {localStorage.setItem('plc_licence_customer_service_disclaimer_days', new Date().getTime().toString())} catch(e){}  }}
        setConfigurationName={(name) => {
          this.props.renameConfiguration(config.id, name)
        }}
        isSaving={this.props.configurationSaver.isSaving}
      >
      </LicenceSavedConfigurationSection>
      {((!appConfiguration.launchFromWorkspace && !appConfiguration.unifiedCheckoutAvailable) || !this._isWrapperMode || this.state.workspaceOptionsOpened) && <DocumentationWrapper>
        <DocumentationSection
          documentsLoading={this.props.documentationReducer.isLoading}
          hideDatasheets={LICENSE_MODELS.SUBSCRIPTION === this.props.configuration.licenseModel}
          datasheetsLoading={this.props.datasheetReducer.isLoading}
          documentTypes={this.props.documentationReducer.documentTypes}
          datasheetTypes={this.props.datasheetReducer.documentTypes}
          downloadDocuments={this.handleDownloadDocuments}
          logExport={this.logDocumentationExport}
          documentationKeys={this.processDocumentationKeys(config)}
        >
        </DocumentationSection>
      </DocumentationWrapper>}
    </SaveWrapper>);
  }

  renderScreenContent = (config) => {
    const mailInformation = getUserInformation();
    return (
      <>
        <ScreenContent fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
          <Content>
          <Notification>
          </Notification>
            <BOMContainer>
              <BomWrapper>
                {this.renderBOM(config)}
              </BomWrapper>
            </BOMContainer>
            {this.renderSavedSection(config)}
            <MobileSection>
              <BomWrapper>
                {this.renderBOM(config)}
              </BomWrapper>
            </MobileSection>
            {this.state.emailForm.isOpen && (
              <EmailFormModal
                senderEmail={mailInformation.senderEmail}
                senderName={mailInformation.senderName}
                onClose={this.handleEmailFormClose}
                onSubmit={this.handleEmailSubmit}
                i10n={I10n}>
              </EmailFormModal>
            )}
          </Content>
          {(window.self === window.parent || appConfiguration.showDistributorSurvey) && !this.props.survey.isLoading && <Survey
            appTitle={I10n.get('app.licence_selector.title')}
            surveyData={this.props.survey?.surveyData}
            getLabel={(key) => I10n.get(key)}
            preselectionnedAnswers={{ 'embedded_survey.choose_a_category': 'embedded_survey.step.power_supply' }}
            onOpen={() => {
              logSurveyOpenEvent(surveyEventTypes.intermediate_open, config.id, softwareStepsConfig.software_selection);
             }}
            onSubmit={(surveyAnswers) => {
              logSurveySubmitEvent(surveyEventTypes.intermediate_sent, config.id, stepsConfig.power_supply, surveyAnswers);
            }}
            fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}
            color={appConfiguration.globalStyles.secondaryColor}
          ></Survey>}
        </ScreenContent>
      </>
    );
  }

  renderWithEventualScrollBar = (screenContent) => {
    return ((this.state.isDesktop && !this.props.applicationParameters.fullScreenEnabled) ? <>{screenContent}</> : <Scrollbars>
      <FullScreenScrollbarWrapper>
        {screenContent}
      </FullScreenScrollbarWrapper>
    </Scrollbars>);
  }

  renderNavigationButtonSection = () => {
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    const buttons = <>
      <CancelWrapper>
        <Button
          id='license-selector-screen-back-button'
          disabled={this.props.configurationSaver.isSaving}
          onClick={event => {
            if (this.props.configuration.servicePlanItems?.length === 0) {
              this.props.setActiveStep(softwareStepsConfig.licence_selector);
            } else {
              this.props.setActiveStep(softwareStepsConfig.service_plan);
            }
          }}
        >
          {I10n.get('app.action.back')}
        </Button>
      </CancelWrapper>
      {!appConfiguration.disableCallByRangeBackToStart && <Button
        primary
        onClick={event => {
          this.confirmationBeforeCancel(isSaved, this.props.backToStart);
        }}>
        {I10n.get('app.action.go_to_start_page')}
      </Button>}
    </>;
    return (
      <>
        <FullScreenNavigationButtonSection>
          {buttons}
        </FullScreenNavigationButtonSection>
        <HiddenNavigationButtonSection>
          {buttons}
        </HiddenNavigationButtonSection>
      </>
    );
  }

  render = () => {
    const config = new Configuration(this.props.configuration);
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    return (
      <Wrapper fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
        <ApplicationFullHeader
          title={I10n.get('app.licence_selector.title')}
          fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}
          shouldShowLogin={appConfiguration.seamlessSession == null}
          setApplicationParameters={this.props.setApplicationParameters}
          userName={appConfiguration.seamlessSession?.name}
          goToStartPage={
            () => {
              this.confirmationBeforeCancel(isSaved, this.props.backToStart);
            }}
          applicationParameters={this.props.applicationParameters}
          steps={getSoftwareStepperLabels()}
          activeStep={softwareStepsConfig.save_screen}
          stepperActions={this.getStepperActions(isSaved)}
          openModal={this.props.openModal}
          closeModal={this.props.closeModal}
          disabled={this.props.configurationSaver.isSaving}
          redirectWithCBR={false}
          mySchneiderLink={buildMySchneiderUrl()}
          isSoftwareLicenseConfiguration={true}
        ></ApplicationFullHeader>
        {this.renderWithEventualScrollBar(this.renderScreenContent(config))}
        {this.renderNavigationButtonSection()}
      </Wrapper>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {
  return {
    openModalFct: (modalTypeWithProps) => dispatch(openModal(modalTypeWithProps)),
    closeModal: () => dispatch(closeModal()),
    exportToXls: (configuration) => dispatch(exportToXLS(configuration, softwareStepsConfig.save_screen)),
    exportToMyProduct: (configuration) => dispatch(exportToMyProduct(configuration)),
    exportToMyProject: (configuration) => dispatch(exportToMyProject(configuration)),
    exportToMyList: (configuration) => dispatch(exportToMyList(configuration)),
    exportToBuyAutomation: (configuration) => dispatch(exportToBuyAutomation(configuration)),
    getSurvey: () => dispatch(getSurvey(surveyTypes.generic)),
    updateShowButtonAnimations: () => dispatch(updateShowButtonAnimations({survey: false})),
    preSaveConfiguration: (configuration, step) => dispatch(preSaveConfiguration(configuration, configurationStatuses.finalized, step)),
    saveConfiguration: (configuration) => dispatch(preSaveConfiguration(configuration)),
    showNotification: (text, type, buttonElement) => dispatch(showNotificationWithButton(text, type, buttonElement)),
    setApplicationParameters: (parameters) => dispatch(setApplicationParameters(parameters)),
    backToStart: () => dispatch(setActiveStep(stepsConfig.start_screen)),
    cancelConfiguration: (configId) => dispatch(cancelConfiguration(configId)),
    setActiveStep: (step) => dispatch(setActiveStep(step)),
    getDocumentation: (configuration) => dispatch(getDocumentation(configuration)),
    getDatasheet: (configuration) => dispatch(getDatasheet(configuration)),
    setServicePlanActivation: (newStatus) => dispatch(setServicePlanActivation(newStatus)),
    resetCallByRangeSelectedItems: () => dispatch(resetCBRSelectedItems()),
    renameConfiguration: (configId, name) => dispatch(renameConfiguration(configId, name)),
    updateMsxSoftwareLicenseReferences: (config) => dispatch(updateMsxSoftwareLicenseReferences(config))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LicenceSelectorSaveScreen);
